import { render, staticRenderFns } from "./TransformDetailInput.vue?vue&type=template&id=462d5cd0&scoped=true&"
import script from "./TransformDetailInput.vue?vue&type=script&lang=js&"
export * from "./TransformDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./TransformDetailInput.vue?vue&type=style&index=0&id=462d5cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d5cd0",
  null
  
)

export default component.exports